
import { supabase } from "@/lib/supabase";
import { ClassDefaults, Organization } from "@/types/organizationTypes";

export const useUpdateClassDefaults = (
  organization: Organization | null,
  setOrganization: (org: Organization) => void,
  organizationId?: string
) => {
  return async (settings: Partial<ClassDefaults>): Promise<Organization | null> => {
    if (!organizationId || !organization) {
      throw new Error("Organization not loaded");
    }
    const updatedSettings = {
      ...(organization.class_defaults || {}),
      ...settings,
    };
    const { data, error } = await supabase
      .from("organizations")
      .update({ class_defaults: updatedSettings })
      .eq("id", organizationId)
      .select()
      .single();

    if (error) {
      throw new Error(error.message);
    }
    const updatedOrg = { ...organization, class_defaults: updatedSettings };
    setOrganization(updatedOrg);
    return updatedOrg;
  };
};
